<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
        </div>
        <!--<graph-submenu :position="graphPosition" />-->
        <div class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ getAggregatedValue }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small-number margin-left-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        v-if="difference !== 0"
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="transition-transform"
                        :class="{
                            'rotate-90': difference < 0,
                            'uk-fill-danger': difference < 0,
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta">{{ title }}</span
            ><br />
        </div>

        <bar-part :chart-data="getChartData" :custom-options="getCustomOptions" />

        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import BarPart from "./graphParts/BarPart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default {
    name: "BarGraph",
    components: {
        BarPart,
        GraphHelp,
        GraphModal,
    },
    mixins: [GraphsMixin],
    data() {
        return {
            activeSubmenu: false,
            dataName: "Messages",
        };
    },
    computed: {
        getChartData() {
            return [this.chartData];
        },
        getCustomOptions() {
            const customOptions = {
                yaxis: {
                    tickAmount: undefined,
                },
            };

            if (this.chartData.data[0]) {
                //search the highest amount of messages and set the tick interval
                const max = this.chartData.data.reduce((prev, current) => (prev.y > current.y ? prev : current));

                if (max.y < 6) {
                    customOptions.yaxis.tickAmount = max.y;
                }
            }

            return customOptions;
        },
    },
};
</script>
